import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleEnum } from '../shared/enum/role.enum';
import { TvfComponent } from './tvf.component';
const defaultRouteGuards = [RoleEnum.TVF.toString()];
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: TvfComponent,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'pedidos',
        loadChildren: async () => (await import('./order/order.module')).OrderModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'triagem',
        loadChildren: async () => (await import('./screening/screening.module')).ScreeningModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'relatorio',
        loadChildren: async () => (await import('./reports/reports.module')).ReportsModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'acessos',
        loadChildren: async () =>
          (await import('../core/access-control/access-control.module')).AccessControlModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'lotes',
        loadChildren: async () =>
          (await import('./lot-manager/lot-manager.module')).LotManagerModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'lmr',
        loadChildren: async () =>
          (await import('./lmr/lmr.module')).LmrModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'erros',
        loadChildren: async () =>
          (await import('./errors-manager/errors-manager.module')).ErrorsManagerModule,
        data: { num: 10, roles: defaultRouteGuards },
      },

      {
        path: 'error-manager',
        loadChildren: async () =>
          (await import('./errors-manager/errors-manager.module')).ErrorsManagerModule,
        data: { num: 10, roles: defaultRouteGuards },
      },

      {
        path: 'logs',
        loadChildren: async () => (await import('./logs/tvf-logs.module')).LogsTvfModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'transportadoras',
        loadChildren: async () => (await import('./carriers/carriers.module')).CarriersModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'error-manager',
        loadChildren: async () => (await import('./carriers/carriers.module')).CarriersModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'varejistas',
        loadChildren: async () => (await import('./retailers/retailers.module')).RetailersModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'lojas',
        loadChildren: async () => (await import('./stores/stores.module')).StoreModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'controle-qualidade',
        loadChildren: async () =>
          (await import('../tvf/quality-control/quality-control.module')).QualityControlModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'recebimento',
        loadChildren: async () =>
          (await import('./stock-entry/stock-entry.module')).StockEntryModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'reincidencia',
        loadChildren: async () =>
          (await import('./relapse/relapse.module')).RelapseModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TvfRoutingModule {}
